<template>
    <div class="cs4-cart__summary">
        <div class="cs4-cart__summaryTotalNoDiscount" v-if="cartTotals.total_items != cartTotals.total_price">{{ dictionary.totalWithoutDiscount }} <span class="cs4-cart__summaryPriceBeforeDiscount">{{getFormattedPrice(cartTotals.total_items)}}</span> </div>
        <div class="cs4-cart__summaryCrystal">+ {{getCrystalAmount()}} {{dictionary.freeCrystals}} <img src="https://comprasocial.me/wp-content/uploads/2019/07/Crystal@2x.png" alt="crystal icon" class="cs4-cart__summaryCrystalIcon"></div>
        <div class="cs4-cart__summaryTotal">{{dictionary.total}}: {{getFormattedPrice(cartTotals.total_price)}}</div>
        <div class="cs4-cart__summaryClickAndContinue" v-on:click="goToCheckout()">
            {{dictionary.clickAndContinue}}
        </div>
    </div>
</template>

<script>
export default {
    props:['cartTotals','dictionary'],
    data(){
        return {

        }
    },
    emits: ['toggleLoading'],
    methods:{
        getFormattedPrice(price, currency = "EUR") {
            const formatter = new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: currency
            });
            return formatter.format(price/100);
        },
        getCrystalAmount(){
            return Math.floor(this.cartTotals.total_price/100)
        },
        goToCheckout(){
            this.$emit('toggleLoading');
            location.href = this.dictionary.checkoutURL;
            this.$emit('toggleLoading');
        }
    }
}
</script>

<style lang="scss" scoped>
.cs4-cart__summary {
    background: linear-gradient(92.18deg, #3456AB 7.84%, #8D47CF 90.91%);
    box-shadow: 0px -6px 20px 5px rgba(0, 0, 0, 0.25);
    min-height: 120px;
    position: absolute;
    bottom: 0;
    z-index: 202;
    width: 100%;
    display: grid;
    grid-template-columns: 0.7fr .7fr 1fr;
    padding: 15px 0;

    &PriceBeforeDiscount{
      text-decoration: line-through;
      text-decoration-thickness: 2px;
    }
  
    &TotalNoDiscount {
      font-weight: 700;
      font-size: 14px;
      grid-column: 2 / span 2;
      text-align: right;
      margin-right: 20px;
    }

    &Crystal {
      font-weight: 700;
      font-size: 15px;
      grid-column: 1 / span 2;
      display: flex;
      align-items: center;
      justify-content: left;
      margin-left: 20px;

      &Icon {
        width: 20px;
        height: 20px;
        margin-left: 10px;
      }
    }

    &Total {
      font-weight: 700;
      font-size: 18px;
      text-align: right;
      margin-right: 20px;
      display: flex;
      align-items: center;
      justify-content: right;
      grid-column: 3;
    }

    &ClickAndContinue {
      background: linear-gradient(270deg, #61ce70, #0c9dc2);
      background-size: 600%;
      animation: gradientAnimation 4s linear infinite;
      border-radius: 25px;  
      grid-column: 1 / span 3;
      font-size: 25px;
      font-weight: 600;
      display: flex;
      justify-content: center;
      align-items: center;
      align-self: center;
      cursor: pointer;
      margin: 0 20px;
      height: 45px;
      overflow: hidden;
      position: relative;
      z-index: 1;

      &::before {
        position: absolute;
        content: '';
        display: inline-block;
        top: -180px;
        left: 0;
        width: 30px;
        height: 100%;
        background-color: #fff;
        animation: shine 3s ease-in-out infinite;
        z-index: -1;
      }
    }
  }

@keyframes gradientAnimation {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
}

@keyframes shine {
  0% { 
    -webkit-transform: scale(0) rotate(45deg); opacity: 0; 
  }
  80% { 
    -webkit-transform: scale(0) rotate(45deg); opacity: 0.5; 
  }
  81% { 
    -webkit-transform: scale(4) rotate(45deg); opacity: 1; 
  }
  100% { 
    -webkit-transform: scale(50) rotate(45deg); opacity: 0; 
  }
}
</style>